export default {
  // ------增值服务（费用中心-Commz）------
  commz: {
    // 增值服务首页
    serviceTitle: '增值服务',
    servicePageDesc: '智界提供的基础服务费用充值和SaaS产品拓展服务',
    categoryServiceCount: '{count}项服务',
    active: '生效中',
    planned: '规划中',
    notOpen: '未开通',
    recharge: '充值',
    purchase: '购买',
    surplus: '剩余额度',
    comingSoon: '规划中，敬请期待',
    openLaterBuy: '后续开放购买',
    openLaterOpen: '后续开放开通',
    // 规划中卡片兜底单位（接口 quotaUnit 为空时按服务类型展示）
    unitQuota: '额度',
    unitGoods: '个',
    unitMaterial: 'GB',
    unitStore: '店',
    unitSeat: '席',
    unitPerm: '权限',
    loadFailed: '加载失败，请刷新重试',
    // 确认订单
    confirmTitle: '确认订单',
    confirmTitleFormat: '{serviceName}-确认订单',
    // 签约信息
    contractInfo: '签约信息',
    contractParty: '签约方',
    brandCode: '品牌编码',
    serviceParty: '服务方',
    performanceBrand: '履约品牌',
    selectPackage: '选购套餐',
    orderSummary: '订单',
    purchaseQuantity: '购买数量',
    currency: '币种',
    priceFormula: '价格',
    subtotal: '合计',
    payFrequency: '付费频率',
    oneTimePay: '一次性付清',
    invoiceTip: '支付后可申请发票',
    unitSms: '条',
    agreePrefix: '我已阅读并同意',
    agreementName: '《自然源数字化在线订购协议》',
    submitOrder: '提交订单',
    createSuccess: '订单创建成功，请完成支付',
    qtyTip: '购买数量为 1~999 的整数',
    // 支付页
    paymentTitle: '订单支付',
    paymentCreateSuccess: '订单创建成功，请尽快支付',
    scanTip: '请使用手机扫码支付',
    qrCodeValidFor: '支付二维码剩余有效时间：{time}',
    qrCodeExpired: '二维码已失效',
    qrCodeExpiredTip: '支付二维码已失效，请重新下单；如已扣款，请先查询支付结果，勿重复支付',
    checkPaymentNow: '我已完成支付，立即查询',
    checkingPayment: '查询中…',
    paymentPendingTip: '暂未查询到支付成功，如已扣款，请稍后查询，勿重复支付',
    paymentQueryFailed: '查询失败，请稍后重试',
    payAmount: '应付金额',
    payMoney: '支付金额',
    purchaseProduct: '购买产品',
    payee: '收款方',
    orderNo: '订单号',
    productName: '产品名称',
    productQty: '购买数量',
    cancelOrder: '取消订单',
    cancelConfirm: '确定取消该订单吗？取消后不可恢复。',
    cancelSuccess: '订单已取消',
    paySuccess: '支付成功',
    paySuccessTip: '支付成功，权益额度将陆续到账，可在订单管理中查看',
    orderClosedTip: '该订单已关闭，如需购买请重新下单',
    reorder: '重新下单',
    goOrderList: '订单管理',
    payTime: '支付时间',
    // 订单管理
    orderListTitle: '订单管理',
    allTab: '全部',
    statusToPay: '待支付',
    statusFinished: '已完成',
    statusClosed: '已关闭',
    productType: '产品类型',
    invoiceStatus: '发票状态',
    serviceDesc: '产品信息描述',
    createTime: '下单时间',
    orderStatus: '订单状态',
    quantity: '数量',
    totalAmount: '订单总金额',
    detail: '详情',
    pay: '支付',
    cancel: '取消订单',
    orderDetails: '订单详情',
    basicInfo: '基本信息',
    orderItems: '订单明细',
    payInfo: '支付信息',
    skuName: '套餐名称',
    unitPrice: '成交单价',
    originalAmount: '原始金额',
    payNo: '支付单号',
    payMethod: '支付方式',
    tradeNo: '商户单号',
    payStatus: '支付状态',
    payAttemptPending: '待提交',
    payAttemptPaying: '支付中',
    payAttemptFailed: '支付失败',
    payAttemptClosed: '支付已关闭',
    closeTime: '关闭时间',
    invoiceNot: '未开票',
    invoiceIn: '开票中',
    invoiceDone: '已开票',
    payMethodQr: '微信扫码',
    payMethodTransfer: '线下转账',
    payMethodBalance: '余额支付',
    payMethodOther: '其他',
    payUnpaid: '未支付',
    payPaid: '已全额支付',
    listLoadFailed: '列表加载失败，请重试',
  },
};
